
import DatasourcesGrid from '../components/Grid';
import { DatasourceProvider } from '../store';

export default function DatasourcesGridLayout() {
  return <DatasourceProvider>
    <DatasourcesGrid />
  </DatasourceProvider>;
}
